import { walletRoutes } from "../../constants/Routes";
const axios = require("axios");

export const getSkillPage = async (skillId) => {
	try {
		let response = await axios.post(walletRoutes.getSkillPage, {
			id: skillId,
		});
		var responseJson = response.data;
		if (!responseJson.success) throw new Error();

		return responseJson;
	} catch (error) {
		console.log(error);
		throw error;
	}
};
